import React, { Component } from 'react';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import {connect} from 'react-redux';
import { withRouter } from "react-router-dom";
import Main from './main';
import UnsavedChangesGuard from './components/unsaved-changes-guard';
// import io from 'socket.io-client';

class App extends Component {

  // constructor(){
  //   super()

  //   this.state = {
  //     endpoint: "http://localhost:5000/watchlist" // this is where we are connecting to with sockets
  //   }
  //    // method for emitting a socket.io event
  //   const socket = io(this.state.endpoint);

  // }

  render() {
    return (
        <ThemeProvider theme={createTheme()}>
              <div className="app-page-wrap" id="app">
                  <UnsavedChangesGuard />
                  <Main />
              </div>
        </ThemeProvider>
    );
  }
}


function mapStateToProps(state){
  return state;
}

export default withRouter(connect(mapStateToProps,null) (App));
